import { create } from "zustand";

export type ViewMode = "document" | "board" | "scene";
export type RightTabId = "inspector" | "chat" | "lancer";
export type LancerPanelMode = "sheet" | "rolllog";

interface ActiveContext {
  entityId: string;
  x: number;
  y: number;
}

interface UIState {
  viewMode: ViewMode;
  isRightPanelOpen: boolean;
  activeRightTab: RightTabId;
  lancerPanelMode: LancerPanelMode;
  lancerPoppedOut: boolean;
  openJournalBlockId: string | null;
  activeContextMenu: ActiveContext | null;
  setViewMode: (mode: ViewMode) => void;
  toggleRightPanel: () => void;
  setRightTab: (tab: RightTabId) => void;
  setLancerPanelMode: (mode: LancerPanelMode) => void;
  toggleLancerPoppedOut: () => void;
  openJournal: (blockId: string) => void;
  closeJournal: () => void;
  setContextMenu: (context: ActiveContext | null) => void;
}

export const useUIStore = create<UIState>((set) => ({
  viewMode: "scene",
  isRightPanelOpen: true,
  activeRightTab: "inspector",
  lancerPanelMode: "sheet",
  lancerPoppedOut: false,
  openJournalBlockId: null,
  activeContextMenu: null,
  setViewMode: (mode) => set({ viewMode: mode }),
  toggleRightPanel: () =>
    set((state) => ({ isRightPanelOpen: !state.isRightPanelOpen })),
  setRightTab: (tab) => set({ activeRightTab: tab }),
  setLancerPanelMode: (mode) => set({ lancerPanelMode: mode }),
  toggleLancerPoppedOut: () =>
    set((state) => ({ lancerPoppedOut: !state.lancerPoppedOut })),
  openJournal: (blockId) => set({ openJournalBlockId: blockId }),
  closeJournal: () => set({ openJournalBlockId: null }),
  setContextMenu: (context) => set({ activeContextMenu: context }),
}));
